import React from "react";
import { Box } from "@chakra-ui/react";
import { Modal, useTranslation } from "@familyzone/component-library";
import { CaptureTool, DiagsCollectTool, PingTool, TracerouteTool } from "../Tools";

const DiagnosticToolsModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      headerText={t("Network Diagnostic Tools")}
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      secondaryCTALabel={t("Close")}
      secondaryCTADisabled={false}
      onSecondaryCTAClick={onClose}
      contentProps={{ style: { overflow: "visible" } }}
    >
      <Box mt="sp16" overflow="auto">
        {isOpen && (
          <>
            <DiagsCollectTool />
            <PingTool />
            <TracerouteTool />
            <CaptureTool />
          </>
        )}
      </Box>
    </Modal>
  );
};

export default DiagnosticToolsModal;
